import { useMemo } from 'react';
import { fetchNonCrmObject, isFetchingFromMultipleSources } from 'framework-asset-preview-lib/internal/shared/api/crm';
import useFetch from './useFetch';
export default function useFetchNonCrmObject(objectTypeId, crmObject) {
  const needsExtraApiCall = useMemo(() => isFetchingFromMultipleSources(objectTypeId), [objectTypeId]);
  const fetchProps = useMemo(() => ({
    fetcher: () => needsExtraApiCall && crmObject ? fetchNonCrmObject(crmObject) : Promise.resolve(undefined),
    skip: !needsExtraApiCall || !crmObject
  }), [crmObject, needsExtraApiCall]);
  return useFetch(fetchProps);
}